import { proxy } from 'valtio';
// Initialize deferredPrompt for use later to show browser install prompt.
let deferredPrompt = undefined;
export const installState = proxy({
    installReady: false,
});
if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        // Stash the event so it can be triggered later.
        deferredPrompt = e;
        // Update UI notify the user they can install the PWA
        installState.installReady = true;
        // Optionally, send analytics event that PWA install promo was shown.
        console.log(`Ready to show custom install prompt`);
    });
}
export function triggerInstall() {
    if (!deferredPrompt)
        return;
    // Show the install prompt
    deferredPrompt.prompt();
}
export function getDeferredPrompt() {
    return deferredPrompt;
}
//# sourceMappingURL=install.js.map